<template>
    <b-card>
         <div slot="header">
          <i class="fa fa-users" aria-hidden="true"></i>
            {{text.userList}}
            <div class="card-header-actions">
            <router-link :to="'/docs/home'" class="card-header-action" rel="noreferrer noopener">
              <small class="text-muted">{{text.docs}}</small>
            </router-link>
          </div>
        </div>
        <b-row>
            <b-col sm="12">
                <alert-fail :show="errorMessage !== ''"> {{ errorMessage }} </alert-fail>
                <b-row>
                    <b-col>
                        <b-form-group
                        label-cols-sm="3"
                        label-cols-lg="2"
                        :label="text.filter"
                        >
                        <b-form-input v-model.lazy="search" size="sm" :placeholder="text.filterUsernameOrFullname"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-row>
                            <b-col md="6"><v-select v-model="permissionChoose" class="users-filter" :options="permissionList" :placeholder="text.filterPermission"></v-select></b-col>
                            <b-col md="6"><v-select v-model="statusChoose" class="users-filter filter-status" :options="statusList" :placeholder="text.filterStatus"></v-select></b-col>
                        </b-row>
                    </b-col>
                </b-row>

                    <b-table
                          stacked="sm"
                          :busy="isBusy"
                          :current-page="pagination.currentPage"
                          :per-page="pagination.numberPerPage"
                          class=""
                          tbody-class="tbody" hover
                          thead-tr-class="thead"
                          @row-clicked="viewDetails"
                          selectable
                          selectedVariant="single"
                          :fields="fields"
                          responsive
                          :items="list">
                          <template slot="avatar" slot-scope="row">
                            <img class="image" :src="row.item.image" alt="Profile picture">
                          </template>
                          <template slot="status" slot-scope="row">
                            <font v-if="'suspend' == row.item.status" class="red">Suspend</font>
                            <font v-else-if="'active' == row.item.status" class="green">Active</font>
                            <font v-else> - </font>
                          </template>
                            <div slot="table-busy" class="text-center text-dark my-2">
                                <b-spinner variant="dark" class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                    <hr/>
                    <b-row>
                    <b-col>
                        <app-paging
                            :totalRows="pagination.totalRows"
                            :page="pagination.currentPage"
                            @changePage="changePage"/>
                    </b-col>
                    </b-row>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import AlertFail from '../../components/alert/AlertFail';
import AppPaging from '../../components/Pagination.vue';
import vSelect from 'vue-select';
import { textUser } from '@/assets/utils/language';

export default {
  data () {
    return {
      search: '',
      permissionChoose: null,
      statusChoose: null,
      errorMessage: '',
      isBusy: false,
      pagination: {
        currentPage: 1,
        numberPerPage: 20,
        totalRows: 20
      },
      fields: [],
      list: [],
      permissionList: [],
      statusList: [
        'active', 'suspend'
      ],
      text: {}
    };
  },
  methods: {
    viewDetails (e) {
      this.$router.push({ name: 'userManagement-details', params: { username: e.username } });
    },
    changePage (e) {
      this.pagination.currentPage = e;
      this.getData();
    },
    handleError (error) {
      this.errorMessage = error.response || error.message;
    },
    getData () {
      this.errorMessage = '';
      this.isBusy = true;
      this.list = [];
      const search = this.search || '';
      this.axios.get(process.env.VUE_APP_ACCESS_CONTROL_URL + '/user/list' +
      `?page=${this.pagination.currentPage}&text=${search}&permission=${this.permissionChoose || ''}&status=${this.statusChoose || ''}`)
        .then(response => {
          const data = response.data.data;
          this.pagination.totalRows = data.users.length;
          if (data) {
            for (const user of data.users) {
              const permission = user.permission.length > 2
                ? user.permission[0] + ', ' + user.permission[1] + ', ...'
                : user.permission.map(value => value).join(', ');
              this.list.push({
                username: user.username,
                fullname: user.fullname,
                permission: permission,
                status: user.status,
                image: user.thumbnail || '/images/avatars/default.jpg'
              });
            }
          }
        })
        .catch(error => {
          this.handleError(error);
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    getPermissionList () {
      this.permissionList = [];
      this.axios.get(process.env.VUE_APP_ACCESS_CONTROL_URL + '/permission')
        .then(response => {
          const data = response.data.data;
          if (data) {
            for (const permission of data.permissions) {
              this.permissionList.push(permission.name);
            }
          }
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    refreshFields () {
      this.fields = [
        { key: 'avatar', label: this.text.avatar },
        { key: 'username', label: this.text.username },
        { key: 'fullname', label: this.text.fullname },
        { key: 'permission', label: this.text.permission },
        { key: 'status', label: this.text.status }
      ];
    }
  },
  components: {
    AlertFail,
    AppPaging,
    'v-select': vSelect
  },
  mounted () {
    this.text = textUser(this.$language);
    this.refreshFields();
    this.getData();
    this.getPermissionList();
  },
  watch: {
    search () {
      this.getData();
    },
    statusChoose () {
      this.getData();
    },
    permissionChoose () {
      this.getData();
    },
    $language: function () {
      this.text = textUser(this.$language);
      this.refreshFields();
    }
  }
};
</script>

<style scoped>
    .red{
        color: #f86c6b;
    }
    .green{
        color: #4dbd74;
    }
    .image{
      max-width: 50px;
      max-height: 50px;
    }
</style>

<style>
    .users-filter .vs__search::placeholder,
    .users-filter .vs__dropdown-toggle,
    .users-filter .vs__dropdown-menu {
        color: #394066;
        font-variant: small-caps;
        border: 1px solid #e4e7ea;
    }
    .filter-status {
        margin-top: 1px;
    }
</style>
